module.exports = __webpack_public_path__ + "static/audiomack-91f208aec6920bcd6284c110332f98bd.svg";